import angularModule from 'FrontRoyalForm/angularModule/scripts/front_royal_form_module';
import template from 'FrontRoyalForm/angularModule/views/invalid_fields_links.html';
import cacheAngularTemplate from 'cacheAngularTemplate';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('invalidFieldsLinks', [
    '$injector',
    function factory($injector) {
        const scrollHelper = $injector.get('scrollHelper');

        return {
            restrict: 'E',
            scope: {
                // `[{ path, label }]`, where the label is already translated and the path addresses a
                // validation schema. See getSchemaFieldErrors in edit_career_profile_dir.js.
                fields: '<',
                // The locale key for the heading above the list. Optional: it falls back to the
                // "complete all required fields" heading. The language list passes its own key,
                // because those fields hold an answer and asking the user to complete them is wrong.
                titleKey: '<?',
            },
            templateUrl,
            link(scope) {
                // Each field marks its input with a `data-field-path` attribute.
                scope.scrollToField = field => {
                    scrollHelper.scrollToElement($(`[data-field-path="${field.path}"]`), true, -10);
                };
            },
        };
    },
]);
